export const environment_prod = {
  production: true,
  enabled: true,
  apiBaseUrl: "https://defectwise-api-apim.azure-api.net/defectwise-api/v1",
  apiSubscriptionKey: "870b3f9cb66440c5b0fc16b689d12369",
  reportServerUrl: "https://server.defectwise.com.au/api/v1",
  /** Not utilised on production */
  reportSubscriptionKey: "",
};
